import React from 'react';
import styles from "./Contacts.scss";
import clockImg from "./img/clock.png";
import mailImg from "./img/mail.png";
import phoneImg from "./img/phone.png";
import questionImg from "./img/questionmark_g.png";
import {__t} from '../../common/lang/text-resource';

const Contacts = () => {
	return (
	  <section className={styles.contacts} data-layout="row	start gutter-none">
		  <div data-layout="col 12 6@md 3@tb">
			  <img src={clockImg} alt={__t('техническа-поддържка-на-хостинг-услугите-без-почи781c4c')}/>
			  <div>
				  <p>{__t("0:00-24:00 часа")}</p>
				  <p>{__t("Без почивни дни")}</p>
			  </div>
		  </div>
		  <div data-layout="col 12 6@md 3@tb">
			  <img src={mailImg} alt={__t("Техническа поддръжка на хостинг услугите")}/>
			  <div>
				  <p className={styles.obfuscateEmail}>{__t("gb.gnitsohrepus@troppus")}</p>
				  <a href="https://support.superhosting.bg"
					 title={__t("Към системата за техническа поддръжка")}>{__t("Техническа поддръжка")}</a>
			  </div>
		  </div>
		  <div data-layout="col 12 6@md 3@tb">
			  <img src={phoneImg} alt={__t("Контакти и офис адрес на СуперХостинг.БГ")}/>
			  <div>
				  <p>
					  <a href={__t("tel:088 55 888 22")}>{__t("088 55 888 22")}</a>
				  </p>
				  <a
					href="/web-hosting-page-contact.php"
					title={__t('контактни-данни-за-връзка-и-адрес-на-офисите-на-с2a6730')}>{__t("Контакти и офис адреси")}</a>
			  </div>
		  </div>
		  <div data-layout="col 12 6@md 3@tb">
			  <img src={questionImg} alt={__t("Помощна информация")}/>
			  <div>
				  <p>{__t("Помощна информация")}</p>
				  <a
					href="https://help.superhosting.bg/"
					target="_blank"
					rel="noopener noreferrer"
					title={__t("Помощна информация")}>{__t("help.superhosting.bg")}</a>
			  </div>
		  </div>
	  </section>
	);
};

export default Contacts;